import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect, withRouter, Link } from 'react-router-dom';
import _ from 'lodash';
import Alert from 'react-s-alert';
import BillerInfo from '../component/BillerInfo';
import DynamicForm from '../component/DynamicForm';
import * as actions from '../actions';
import * as c from '../constants';
// import logo from '../../../assets/img/logo.png';
import icn_back from '../../../assets/img/icons/back.svg';
import icn_next from '../../../assets/img/icons/next.svg';

class Biller extends Component {
  static propTypes = {
    returnUrl: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.string,
    ]),
    error: PropTypes.instanceOf(Object).isRequired,
    inquire: PropTypes.func.isRequired,
    validate: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isValidating: PropTypes.bool.isRequired,
    inquiry_no: PropTypes.string.isRequired,
    biller: PropTypes.instanceOf(Object).isRequired,
    // partner: PropTypes.instanceOf(Object).isRequired,
    history: PropTypes.instanceOf(Object).isRequired,
    match: PropTypes.instanceOf(Object).isRequired,
    billerFormValues: PropTypes.instanceOf(Object).isRequired,
    location: PropTypes.instanceOf(Object).isRequired,
  }

  static defaultProps = {
    returnUrl: false,
  }

  formRef = React.createRef();

  componentDidMount() {
    const { biller } = this.props;
    // this.formRef.current.setFormData(payload);
    this.initForm();

    if (!_.isEmpty(biller)) return;
    const { inquire, inquiry_no } = this.props;
    inquire(inquiry_no);
  }

  componentDidUpdate(props) {
    const { biller: oldBiller } = props;
    const { biller: newBiller } = this.props;
    if (!_.isEqual(oldBiller, newBiller)) {
      this.initForm();
    }
  }

  initForm = () => {
    try {
      if (!this.formRef.current) return;
      const { location } = this.props;
      const state = location.state || {};
      const payload = state.payload || {};
      this.formRef.current.setFormData(payload);
    } catch (err) {
      console.log(err); // eslint-disable-line
      // do nothing...
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();
    try {
      const args = _.omit(this.formRef.current.state, ['_key', 'billers']);
      if (_.isEmpty(args)) {
        Alert.warning('Please fill out atleast 1 field');
        return;
      }
      const {
        validate,
        biller,
        inquiry_no,
      } = this.props;
      validate(inquiry_no, { ...args, biller_code: biller.code }, () => {
        const { history, match } = this.props;
        history.push({
          pathname: `${match.url}/summary`,
          state: {
            biller,
            payload: args,
          },
        });
      });
    } catch (err) {
      Alert.danger('Unable to submit form!');
    }
  }

  render() {
    const {
      biller, isLoading, isValidating, returnUrl,
    } = this.props;

    if (isLoading) {
      return (
        <div className="generic-list-loader shadow-lg" />
      );
    }

    const {
      error, inquiry_no, billerFormValues,
    } = this.props;

    if (!_.isEmpty(error)) {
      return <Redirect to={`/${inquiry_no}`} />;
    }

    const billerMeta = Array.isArray(biller.meta) ? biller.meta : _.get(biller, 'meta.parameters') || [];

    return (
      <div className="container outer-wrapper">
        <div className="row mb-3">
          <div className="col mx-auto inner-wrapper">
            {/* <div className="text-center">
              <img src={logo} className="img-fluid logo mb-2" alt="" />
              <h6>MultiSys Payment Facility</h6>
            </div> */}
            <div className="pb-3 main-container mt-3">
              { isValidating && <div className="generic-list-loader shadow-lg" /> }
              <form onSubmit={this.handleSubmit}>
                <div>
                  { (!_.isEmpty(biller)) ? (
                    <div>
                      <div>
                        <BillerInfo data={biller} />
                      </div>
                      { billerMeta.length < 1 ? (
                        <div className="alert alert-warning text-center mt-5 mx-3 mb-3">
                          <h5 className="mb-0">Sorry for the inconvenience.</h5>
                          <div>Biller is currently under maintenance.</div>
                        </div>
                      ) : (
                        <React.Fragment>
                          <div className="mt-5 px-5">
                            <DynamicForm
                              ref={this.formRef}
                              format={billerMeta}
                              readOnlyValues={billerFormValues}
                            />
                          </div>
                          <hr />
                        </React.Fragment>
                      )}
                      <div className="d-flex justify-content-center">
                        {returnUrl && (
                          <Link className="btn btn-secondary btn-lg mr-2" to={returnUrl}>
                            <span className="icon">
                              <img src={icn_back} className="img-fluid" alt="" />
                            </span>
                            <span className="text">
                              Back
                            </span>
                          </Link>
                        )}
                        { billerMeta.length > 0 && (
                          <button
                            className="btn btn-primary btn-lg"
                            type="submit"
                            disabled={isValidating}
                            style={{
                              // background: partner.header_color || '#d03d40',
                              // color: partner.button_label_color || '#fff',
                            }}
                          >
                            <span className="text">
                              Next
                            </span>
                            <span className="icon">
                              <img src={icn_next} className="img-fluid" alt="" />
                            </span>
                          </button>
                        )}
                      </div>
                    </div>
                  ) : (
                    <div className="text-center p-3">
                      <div className="alert alert-danger">
                        <div>Sorry for the inconvenience.</div>
                        <div>Unable to load biller details. Please try again later.</div>
                      </div>
                    </div>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col text-center">
            <p className="mb-0 text-muted"><small>MultiSys Payment Facility v.1.0</small></p>
            <small className="text-muted">www.MultiSyscorp.com</small>
          </div>
        </div>
      </div>

    );
  }
}

const mapStateToProps = ({ api }, { match }) => ({
  inquiry_no: match.params.inquiry_no,
  biller: _.isEmpty(_.get(api, `${c.INQUIRE}.item.formable.biller`) || {})
    ? (_.get(api, `${c.INQUIRE}.item.formable.billers`) || []).find(x => x.code === match.params.biller_code) || {}
    : _.get(api, `${c.INQUIRE}.item.formable.biller`) || {},
  billerFormValues: _.omit(_.get(api, `${c.INQUIRE}.item.formable`) || {}, ['biller', 'biller_code']) || {},
  partner: _.get(api, `${c.INQUIRE}.item.partner`) || {},
  error: _.get(api, `error.${c.INQUIRE}.response`) || {},
  isLoading: api.loading.indexOf(c.INQUIRE) > -1,
  isValidating: api.loading.indexOf(c.VALIDATE) > -1,
});

export default withRouter(connect(mapStateToProps, actions)(Biller));
